import React, { Component } from 'react';
import PerfilItem from './PerfilItem';
import { GenericSimpleButton} from 'com-gyf-webcore-userinterfacecomponents';
class PerfilesSeleccionados extends Component {
    constructor(props) {
        super(props)
    }

    showMoreProfiles = () => {
        this.props.showMoreProfiles();
    }

    showLessProfiles = () => {
        this.props.showLessProfiles();
    }

    render() {
        let data = this.props.perfilesSeleccionados;
        let profilesManagerButton = null;

        if (data.length > 0) {
            if (data.length > 10) {
                if (this.props.showProfiles == false) {
                    let originalDataSize = data.length;
                    data = data.slice(0, 10);

                    let moreProfilesText = "Ver todas (" + originalDataSize + ")...";
                    let moreProfiles = <GenericSimpleButton buttonType="button" text={moreProfilesText} buttonClass="btn btn-link" onClick={this.showMoreProfiles} />;
                    profilesManagerButton = moreProfiles;
                }
                else {
                    let closeProfilesList = <GenericSimpleButton buttonType="button" text="Cerrar la lista" buttonClass="btn btn-link" onClick={this.showLessProfiles} />;
                    profilesManagerButton = closeProfilesList;
                }
            }
        }

        if (data) {
            var profilesNodes = data.map((profile) => {
                return <PerfilItem
                    key={"Profile_" + profile.Id}
                    id={profile.Id}
                    codigo={profile.Codigo}
                    deletePerfil={this.props.deletePerfil} />
            })
        }

        return (
            data.length > 0 &&
                <div className="row">
                    <div className="col-xs-12">
                        <ul className="no-bullets no-margin">
                            {profilesNodes}
                            {profilesManagerButton}
                        </ul>
                    </div>
                </div>
        );
    }
}

export default PerfilesSeleccionados;